import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

import {useCalculatorWindowStore} from './calculatorWindow.store';

/**
 * The one flag guarding every in-app calculator surface — the standalone
 * routes (via `InAppCalculatorGate`) and the embedded practice window
 * (via the hook below). Exported so the two cannot drift apart.
 */
export const IN_APP_CALCULATOR_FLAG = 'in_app_calculator';

/**
 * One gate for every calculator surface: the toolbar button that opens the
 * window and the window itself both call this, so the entry point can never
 * offer something the window would refuse to show.
 *
 * A flag still loading counts as unavailable, so the button appears once and
 * stays rather than flickering in as the flag resolves. Past the flag, the
 * practice view hosting the window decides through the store's `tier`.
 */
export function useIsCalculatorAvailable(): boolean {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled(IN_APP_CALCULATOR_FLAG);
  const tier = useCalculatorWindowStore((state) => state.tier);

  return isFeatureEnabled && !isLoading && tier !== 'none';
}
